import React from "react";
import FulfilledList from "../../components/fullfillment/fullfillmentList";

export const Fulfilled = () => {
  return (
<FulfilledList status={'sent'} listTitle='FULFILLED FILES'  exportButton="true"/>
  );
};

export default Fulfilled;